import { render, staticRenderFns } from "./volunteerHubPage.vue?vue&type=template&id=749f6c2f&scoped=true"
import script from "./volunteerHubPage.vue?vue&type=script&lang=js"
export * from "./volunteerHubPage.vue?vue&type=script&lang=js"
import style0 from "./volunteerHubPage.vue?vue&type=style&index=0&id=749f6c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749f6c2f",
  null
  
)

export default component.exports